import { render, staticRenderFns } from "./PsiRowDataCompare.vue?vue&type=template&id=d2b4f172&scoped=true"
import script from "./PsiRowDataCompare.vue?vue&type=script&lang=js"
export * from "./PsiRowDataCompare.vue?vue&type=script&lang=js"
import style0 from "./PsiRowDataCompare.vue?vue&type=style&index=0&id=d2b4f172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b4f172",
  null
  
)

export default component.exports